<div class="rp-container">
  <p class="rp-hint">
    Pick a folder of per-slice GeoJSON files, a GeoJSON file, or a label volume (.nii, .nii.gz, .nrrd)
    together with its ontology JSON (Ctrl/⌘-click to pick several).
  </p>
  <p-tree
    [value]="nodes"
    scrollHeight="360px"
    [loading]="loading && nodes.length === 0"
    selectionMode="multiple"
    [metaKeySelection]="true"
    [(selection)]="selected"
    (onNodeExpand)="onNodeExpand($event)"
  >
    <ng-template let-node pTemplate="default">
      <span [class.rp-unpickable]="!isPickable(node)">{{ node.label }}</span>
      <p-progressSpinner
        *ngIf="node.loading"
        styleClass="rp-node-spinner"
        strokeWidth="6"
      ></p-progressSpinner>
    </ng-template>
    <ng-template let-node pTemplate="loadmore">
      <button type="button" class="rp-load-more-btn" (click)="onLoadMore($event, node)">More...</button>
    </ng-template>
    <ng-template let-node pTemplate="loadingmore">
      <p-progressSpinner styleClass="rp-node-spinner" strokeWidth="6"></p-progressSpinner>
    </ng-template>
  </p-tree>

  <p *ngIf="importProblem" class="rp-problem">
    <i class="pi pi-exclamation-triangle"></i> {{ importProblem }}
  </p>

  <div class="rp-actions">
    <button pButton label="Cancel" class="p-button-text p-button-sm" (click)="onCancel()"></button>
    <button
      pButton
      label="Import"
      icon="pi pi-cloud-download"
      class="p-button-sm"
      [disabled]="!canImport"
      (click)="onImport()"
    ></button>
  </div>
</div>
